module.exports = __webpack_public_path__ + "files/b0dbd548d37e054943b79dd3c12ef981.svg";